import axios from "axios";

const api = process.env.REACT_APP_API_RESOURCE || "";

const consultarRecursos = async (token, description) => {
  const path = "/resources";
  const apiUrl = `${api}${path}?path=eventdocuments/${description}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", // opcional, pero recomendable
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error al consultar eventos:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const crearRecurso_v2 = async (token, data) => {
  const path = "/resources";
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error al crear monitoreo:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const crearRecurso = async (token, file = {}, nombre, detalles, typeFile) => {
  const path = "/resources";
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, file, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": typeFile,
        "x-file-name": nombre,
        "x-file-details": detalles,
      },
      maxBodyLength: Infinity, // Por si es un archivo grande
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error al subir recurso:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const eliminaRecurso = async (token, idTemplate) => {
  const path = "/resources/";
  const apiUrl = `${api}${path}${idTemplate}`;
  const data = JSON.stringify({});
  try {
    const response = await axios.delete(apiUrl, {
      data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error al eliminar monitoreo:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const resourceService = {
  consultarRecursos,
  crearRecurso,
  eliminaRecurso,
  crearRecurso_v2,
};

export default resourceService;
